let routes = [];
add_routes([
    'personal',
    'certificates',
    'subsidies',
    'login',
    'finances',
    'payment',
    'admin-payments-system',
    'test',
    'dev',
    'lol',
    '404'
]);


function add_routes(v) {

    v.forEach(i => {
        if(i==='')return;
        let a = require('./' + i + '/index.js').default;
        a.forEach(ii => {
            routes.push(ii);
        });
    });
}

export default routes;
